import { trackFootfallEvent } from 'src/utils/footfall';
import { Event } from 'src/constants/footfall';

type PostEventProps = {
  clickMetadata: { section: string, origin?: string };
  isOnAvatarClick?: boolean;
  isOnCommunityClick?: boolean;
  isOnUsernameClick?: boolean;
  isOnTotalResponsesClick?: boolean;
  isOnFirstToReplyClick?: boolean;
  isOnBodyClick?: boolean;
}
type PostEventReturn = {
  onCommunityClick?: () => void;
  onAvatarClick?: () => void;
  onUsernameClick?: () => void;
  onTotalResponsesClick?: () => void;
  onFirstToReplyClick?: () => void;
  onBodyClick?: () => void;
}

export const clickEventsPost = ({
  clickMetadata,
  isOnAvatarClick = true,
  isOnCommunityClick = true,
  isOnUsernameClick = true,
  isOnTotalResponsesClick = true,
  isOnFirstToReplyClick = true,
  isOnBodyClick = true }: PostEventProps): PostEventReturn => {
  return {
    ...(isOnCommunityClick && {
      onCommunityClick: () => {
        trackFootfallEvent(Event.Clicked, {
          clickType: 'post-community',
          clickMetadata: clickMetadata,
        });
      },
    }),
    ...(isOnAvatarClick && {
      onAvatarClick: () => {
        trackFootfallEvent(Event.Clicked, {
          clickType: 'post-avatar',
          clickMetadata: clickMetadata,
        });
      },
    }),
    ...(isOnUsernameClick && {
      onUsernameClick: () => {
        trackFootfallEvent(Event.Clicked, {
          clickType: 'post-username',
          clickMetadata: clickMetadata,
        });
      },
    }),
    ...(isOnTotalResponsesClick && {
      onTotalResponsesClick: () => {
        trackFootfallEvent(Event.Clicked, {
          clickType: 'number-of-replies',
          clickMetadata: clickMetadata,
        });
      },
    }),
    ...(isOnFirstToReplyClick && {
      onFirstToReplyClick: () => {
        trackFootfallEvent(Event.Clicked, {
          clickType: 'post-be-the-first-to-reply',
          clickMetadata: clickMetadata,
        });
      },
    }),
    ...(isOnBodyClick && {
      onBodyClick: () => {
        trackFootfallEvent(Event.Clicked, {
          clickType: 'post-body',
          clickMetadata: clickMetadata,
        });
      },
    }),
  };
};

type ReplyEventProps = {
  replyAsPost?: boolean;
  clickMetadata: { section: string, origin?: string };
  isOnAvatarClick?: boolean;
  isOnCommunityClick?: boolean;
  isOnBodyClick?: boolean;
  isOnMetaTextClick?: boolean;
}
type ReplyEventReturn = {
  onCommunityClick?: () => void;
  onAvatarClick?: () => void;
  onBodyClick?: () => void;
  isOnMetaTextClick?: () => void;
}

export const clickEventsReply = ({
  clickMetadata,
  replyAsPost = false,
  isOnAvatarClick = true,
  isOnCommunityClick = true,
  isOnBodyClick = true,
  isOnMetaTextClick = true,
}: ReplyEventProps): ReplyEventReturn => {
  return {
    ...(isOnCommunityClick && {
      onCommunityClick: () => {
        trackFootfallEvent(Event.Clicked, {
          clickType: replyAsPost ? 'community-reply' : 'community-latest-reply',
          clickMetadata: clickMetadata,
        });
      },
    }),
    ...(isOnAvatarClick && {
      onAvatarClick: () => {
        trackFootfallEvent(Event.Clicked, {
          clickType: replyAsPost ? 'avatar-reply' : 'avatar-latest-reply',
          clickMetadata: clickMetadata,
        });
      },
    }),
    ...(isOnBodyClick && {
      onBodyClick: () => {
        trackFootfallEvent(Event.Clicked, {
          clickType: replyAsPost ? 'clicked-reply' : 'clicked-latest-reply',
          clickMetadata: clickMetadata,
        });
      },
    }),
    ...(isOnMetaTextClick && {
      isOnMetaTextClick: () => {
        trackFootfallEvent(Event.Clicked, {
          clickType: 'info-latest-reply',
          clickMetadata: clickMetadata,
        });
      },
    }),
  };
};
